import PropTypes from 'prop-types';

import { useIntl } from '@zenbusiness/application-commons-intl';

import Display from './Display';

const EmailAddress = ({ title = 'Order Details', taskData: { fullEmailAddress: email } = {}, onClose }) => {
  const { formatMessage: fm } = useIntl();

  const sections = [
    {
      title: fm({ id: 'orderView.items.emailAddress' }),
      filter: !!email,
      items: [{ content: email, xs: 12 }],
    },
  ];

  return <Display onClose={onClose} sections={sections} title={title} />;
};

EmailAddress.propTypes = {
  title: PropTypes.string,
  taskData: PropTypes.shape({}).isRequired,
  onClose: PropTypes.func.isRequired,
};

export default EmailAddress;
